// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".total-price[data-v-250de716]{font-size:18px;font-weight:700;line-height:24px}.total-price__price[data-v-250de716]{font-size:22px;font-weight:700;line-height:20px}.bundle-item-disabled[data-v-250de716]{opacity:.5}.bundle-item-description[data-v-250de716]{-ms-flex-item-align:center;align-self:center}", ""]);
// Exports
module.exports = exports;
